import React, { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_CINEMATIC } from '../types/motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  distance?: number;
}
export function Reveal({
  children,
  delay = 0,
  className,
  distance = 26
}: RevealProps) {
  const reduced = useReducedMotion();
  if (reduced) {
    return <div className={className} data-id="element-37" data-mp="2jqq29qr9fhhd">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: distance,
    filter: 'blur(8px)'
  }} whileInView={{
    opacity: 1,
    y: 0,
    filter: 'blur(0px)'
  }} viewport={{
    once: true,
    amount: 0.35
  }} transition={{
    duration: 1.1,
    delay,
    ease: EASE_CINEMATIC
  }} data-id="element-38" data-mp="2jsj8j4xynzou">
      {children}
    </motion.div>;
}